<script setup lang="ts">
import type { Broker } from '~~/types/Broker'

const props = defineProps<{
  broker: Broker
}>()

const location = computed(() => props.broker.top_5_locations?.[0])

const name = computed(() => location.value?.name)

const content = {
  title: `Soortgelijke makelaars in ${location.value?.name}`,
  description: `Benieuwd welke makelaar vergelijkbaar is in de regio van ${location.value?.name} en vergelijkbaar is aan ${name.value}. Dit op basis van het aantal verkopen, de gemiddelde verkoopprijs en en mix van allerlei verkoopcijfers.
`,
}

const links = computed(() => {
  return props.broker?.similar_brokers.map((broker) => {
    return {
      label: broker.broker_name,
      to: broker.url,
      color: 'neutral',
      variant: 'ghost',
    }
  })
})
</script>

<template>
  <div>
    <UPageSection
      :title="content.title"
      :description="content.description"
      :links="links"
    />
  </div>
</template>
